// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Edited = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <circle cx={9} cy={9} r={4.5} stroke="currentColor" />
    <path fill="currentColor" d="M9 12a3 3 0 1 1 0-6z" />
  </svg>
);
const ForwardRef = forwardRef(Edited);
export default ForwardRef;
